angular.module("app").directive('confirmPassword', function() {
    return {
        require: 'ngModel',
        scope: {
            viewValue: '=',
            reference: '=confirmPassword'

        },
        link: function(scope, elm, attrs, ctrl) {
            scope.viewValue = ctrl;
            ctrl.$parsers.unshift(function(viewValue) {
                var noMatch = viewValue != scope.reference;
                ctrl.$setValidity('noMatch', !noMatch);
                return noMatch;
            });

            scope.$watch("reference", function(value) {
                ctrl.$setValidity('noMatch', value === ctrl.$viewValue);
            });
        }
    }
});